import React from 'react';

export function AtlasLogo({ size = 26, color = 'var(--accent)', wordmark = true, drishti = true, dark = false }) {
  const textColor = dark ? '#e8ecf3' : '#0f1520';
  const subColor = dark ? '#9aa5ba' : '#6b7385';
  return (
    <div className="inline-flex items-center gap-2.5 font-sans">
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <circle cx="16" cy="16" r="15" fill={color} />
        <path d="M16 7c-3.3 0-6 2.6-6 5.8 0 4.4 6 10.2 6 10.2s6-5.8 6-10.2C22 9.6 19.3 7 16 7z" fill="#fff" />
        <circle cx="16" cy="13" r="2.2" fill={color} />
      </svg>
      {wordmark && (
        <div className="flex items-baseline gap-2">
          <span
            className="font-bold tracking-[0.02em]"
            style={{ fontSize: size * 0.62, color: textColor }}
          >
            Atlas
          </span>
          {drishti && (
            <span
              className="font-medium uppercase tracking-[0.05em]"
              style={{ fontSize: size * 0.4, color: subColor }}
            >
              by Drishti
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default AtlasLogo;
